// Module imports
import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthService, IPredictionPersonnelBO } from '@mapfre-tech/amap3';
import { filter } from 'rxjs/operators';

/**
 * Prediction personnel service
 */
@Injectable({
  providedIn: 'root'
})
export class WorkersService {

  /**
   * Component constructor
   */
  constructor(private http: HttpClient, private authService: AuthService) { }

  className = 'WorkersService';

  /**
   * Get all personnel predictions
   */

  getAllPersonnelPredictions(orgStructId = '', exercise = null): Observable<IPredictionPersonnelBO[]> {
    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    const params: any = {};
    if (exercise) {
      params.exercise = exercise;
    }
    return this.http.get<IPredictionPersonnelBO[]>(environment.base_URL + `/personnel-predictions`, { params })
  }

  /**
   * Get all personnel predictions
   */
  getAllPersonnel(orgStructId = '', exercise = null): Observable<IPredictionPersonnelBO[]> {
    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    const params: any = {};
    if (exercise) {
      params.exercise = exercise;
    }
    return this.http.get<IPredictionPersonnelBO[]>(environment.base_URL + `/personnel-predictions/organizational/${orgStructId}`, { params })
  }

  /**
   * Get personnel prediction by id
   */
  getPersonnelById(personnelId: number): Observable<IPredictionPersonnelBO[]> {
    return this.http.get<IPredictionPersonnelBO[]>(environment.base_URL + `/personnel-predictions/${personnelId}`)
  }

  /**
   * Create a prediction personnel
   */
  newPersonnel(personnel: IPredictionPersonnelBO): Observable<IPredictionPersonnelBO[]> {
    return this.http.post<IPredictionPersonnelBO[]>(environment.base_URL + "/personnel-predictions", personnel);
  }

  /**
   * Get personnel template
   * @param orgStructId 
   */
  getPersonnelTemplate(orgStructId: number): Observable<IPredictionPersonnelBO[]> {
    if (!orgStructId) {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk;
    }
    return this.http.get<IPredictionPersonnelBO[]>(environment.base_URL + `/personnel-predictions/template/${orgStructId}`)
  }
}
